import { TableCell, TableRow } from '@mui/material';
import * as R from 'ramda';
import { memo } from 'react';
import { teceoGrayPrimary } from '../../../../../../../../../../../../Theme';
import Typography from '../../../../../../../../../../../../components/Typography/Typography';
import { SelloutRowItem } from '../../../../../types/selloutRows.types';

export interface SelloutTableRowProps {
  data: SelloutRowItem[];
}

const SelloutTableRow = ({ data }: SelloutTableRowProps) => {
  return (
    <TableRow>
      {data.map((sku) => (
        <TableCell key={sku.skuId} style={{ height: '46px' }}>
          {!R.isNil(sku.value) && <Typography color={teceoGrayPrimary}>{sku.value}</Typography>}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default memo(SelloutTableRow);
